<template>
	<div class="bumpers">
		<Component
			:is="template(bumper)"
			v-for="(bumper, index) in bumpers"
			:key="index"
			:avatar="bumper.avatar"
			:name="bumper.name"
			:options="bumper.options"
			:added="offerInCart(bumper.offer_id)"
			:updating="bumperLoading(bumper.offer_id)"
			:disabled="bumperDisabled(bumper.offer_id)"
			@toggle="toggleOffer(bumper.offer_id)"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import AddToOrderBumper from './AddToOrderBumper.vue';
import CheckboxBumper from './CheckboxBumper.vue';
import ModalBumper from './ModalBumper.vue';

export default {
	components: {
		AddToOrderBumper,
		CheckboxBumper,
		ModalBumper,
	},

	props: {
		isModal: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			selectedOfferId: null,
		};
	},

	computed: {
		...mapState('checkout', ['bumpers', 'modifyingCart']),
		...mapGetters('checkout', ['itemForOffer']),
	},

	methods: {
		...mapActions('checkout', ['addOfferToCart', 'removeOfferFromCart']),
		template(bumper) {
			return this.isModal ? 'ModalBumper' : bumper.template;
		},
		offerInCart(offerId) {
			return Boolean(this.itemForOffer(offerId));
		},
		bumperLoading(offerId) {
			return this.modifyingCart && this.selectedOfferId === offerId;
		},
		bumperDisabled(offerId) {
			return this.modifyingCart && this.selectedOfferId !== offerId;
		},
		async toggleOffer(offerId) {
			this.selectedOfferId = offerId;

			const toggleMethod = this.offerInCart(offerId)
				? this.removeOfferFromCart
				: this.addOfferToCart;

			await toggleMethod(offerId);

			this.selectedOfferId = null;
		},
	},
};
</script>

<style lang="scss" scoped>
.bumpers {
	display: flex;
	flex-direction: column;
	gap: var(--size-md);
}
</style>
